// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__BbyCU","file":"styles_file__ZXDNV"};